import { render } from "./ComponentDialogStatic.vue?vue&type=template&id=e7651ba8"
import script from "./ComponentDialogStatic.vue?vue&type=script&lang=js"
export * from "./ComponentDialogStatic.vue?vue&type=script&lang=js"

import "./ComponentDialogStatic.vue?vue&type=style&index=0&id=e7651ba8&lang=css"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__